import { ref } from 'vue';
import CatalogProductsAPI from 'dashboard/api/catalogProducts';

export function useCatalogProducts() {
  const products = ref([]);
  const isLoading = ref(false);
  const catalogId = ref(null);
  const nextCursor = ref(null);
  const hasMore = ref(false);
  const error = ref(null);

  const fetchProducts = async (inboxId, query = '') => {
    isLoading.value = true;
    error.value = null;
    try {
      const response = await CatalogProductsAPI.get(inboxId, {
        q: query || undefined,
        limit: 100,
        all: query ? undefined : true,
      });
      products.value = response.data.products || [];
      catalogId.value = response.data.catalog_id;
      nextCursor.value = response.data.paging?.cursors?.after;
      hasMore.value = !!response.data.paging?.next;
    } catch (err) {
      error.value = err.response?.data?.error || err.message;
      products.value = [];
    } finally {
      isLoading.value = false;
    }
  };

  const loadMore = async inboxId => {
    if (!hasMore.value || !nextCursor.value) return;
    isLoading.value = true;
    try {
      const response = await CatalogProductsAPI.get(inboxId, {
        after: nextCursor.value,
        limit: 100,
      });
      products.value = [...products.value, ...(response.data.products || [])];
      nextCursor.value = response.data.paging?.cursors?.after;
      hasMore.value = !!response.data.paging?.next;
    } catch (err) {
      error.value = err.response?.data?.error || err.message;
    } finally {
      isLoading.value = false;
    }
  };

  const resetProducts = () => {
    products.value = [];
    catalogId.value = null;
    nextCursor.value = null;
    hasMore.value = false;
    error.value = null;
  };

  return {
    products,
    isLoading,
    catalogId,
    hasMore,
    error,
    fetchProducts,
    loadMore,
    resetProducts,
  };
}
